import moment from "moment/moment"

const EQUIPMENT_REQUEST_STATUS_CHOICES = {
    S: 'Submitted',
    A: 'Approved',
    H: 'Shipped'
}

export function cleanEquipmentRequestData(requests, filterBy) {
    let list = []

    requests.filter(request => {
        if(filterBy == "A"){ return true }
        return EQUIPMENT_REQUEST_STATUS_CHOICES[request.status] == filterBy
    })
    .forEach(request => {

        let listItem = {}

        // id
        listItem['id'] = request.id

        // job
        listItem['job'] = request.job.name

        // status
        listItem['status'] = EQUIPMENT_REQUEST_STATUS_CHOICES[request.status]

        // requestedBy
        listItem['requestedBy'] = request.requestedBy ? `${request.requestedBy.firstName} ${request.requestedBy.lastName}` : ''

        // numItems
        listItem['numItems'] = request.equipmentRequestItemsForEquipmentRequest.length

        // date requested
        listItem['dateRequested'] = moment(request.datetimeCreated).format("MM/DD/YYYY")

        // date fulfilled
        listItem['datetimeFulfilled'] = moment(request.datetimeFulfilled).isValid() ? moment(request.datetimeFulfilled).format("MM/DD/YYYY h:mm a") : null

        list.push(listItem)
    })

    return list
}